import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveFillUpTabs = function JoveFillUpTabs(props) {
  var list = props.list,
      value = props.value,
      valueChange = props.valueChange;

  var _useState = useState([]),
      tabList = _useState[0],
      setTabList = _useState[1];

  var _useState2 = useState(),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setTabList(list || []);
  }, [list]);
  useEffect(function () {
    setCurrentTab(value);
  }, [value]);
  /**
   * methods
   */

  var clickTabAction = function clickTabAction(item) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item.value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-row items-center space-x-2",
    children: tabList.map(function (item) {
      return /*#__PURE__*/_jsx(Box, {
        className: clsx('cursor-pointer rounded-lg px-[10px] py-[6px]', {
          'bg-primary-black text-white': currentTab === item.value
        }),
        onClick: function onClick() {
          return clickTabAction(item);
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "font-bold",
          children: item.label
        })
      }, item.value);
    })
  });
};

export default JoveFillUpTabs;